var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiggenerator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1,17.2c0-3.8,0-7.7,0-11.6c7.3,0,14.6,0,21.9,0c0,3.9,0,7.7,0,11.6c-0.1,0-0.2,0-0.3,0c-7.1,0-14.3,0-21.4,0 C1.2,17.2,1.2,17.2,1.1,17.2z M16.5,11.4c0-2.5-2-4.5-4.5-4.5s-4.5,2-4.5,4.5s2,4.5,4.5,4.5S16.5,13.9,16.5,11.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.1,18.4c0.1,0,0.2,0,0.3,0c7.1,0,14.3,0,21.4,0c0.1,0,0.2,0,0.3,0c0,1.3,0,2.6,0,3.8c-0.1,0-0.2,0-0.2,0 c-1.5,0-2.9,0-4.4,0c-0.2,0-0.3-0.1-0.3-0.2c-0.3-0.3-0.7-0.7-1-1C17,21,16.9,21,16.7,21c-3.1,0-6.3,0-9.4,0C7.2,21,7.1,21,7,21.1 c-0.3,0.3-0.7,0.7-1,1c-0.1,0.1-0.2,0.2-0.4,0.2c-1.5,0-3.1,0-4.6,0C1.1,21,1.1,19.8,1.1,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.1,1.7c2.6,0,5.2,0,7.7,0c0,0.4,0,0.8,0,1.3C8.4,3,8,3,7.5,3c0,0.4,0,0.8,0,1.3c-1.7,0-3.5,0-5.2,0c0-0.4,0-0.8,0-1.3 C1.9,3,1.5,3,1.1,3C1.1,2.6,1.1,2.2,1.1,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.3,11.4c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2C13.8,8.2,15.3,9.6,15.3,11.4z M12.6,13.5 c0.3-0.9,0.6-1.9,0.9-2.8c-0.4,0-0.9,0-1.3,0c0.1-0.4,0.2-0.7,0.3-1.1c-0.4-0.2-0.8-0.3-1.2-0.4c-0.3,0.9-0.6,1.9-0.9,2.8 c0.4,0,0.9,0,1.3,0c-0.1,0.4-0.2,0.7-0.3,1.1C11.9,13.2,12.2,13.4,12.6,13.5z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiggenerator);
export default __webpack_public_path__ + "static/media/biggenerator.54392a219c474200262dc28662443a1f.svg";
export { ForwardRef as ReactComponent };